export default __webpack_public_path__ + "static/media/education-safety-net.6b13720f.jpg";